import { EnumBillType, EnumBillTypeOption } from "./EnumBillType";
import DtoListItemBill from "./DtoListItemBill";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestFinishPoolBill {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 
     */
    OrderId?: string;
    /**
     * 
     */
    Type?: EnumBillType;
    /**
     * 
     */
    BLNOs?: string[];
    /**
     * 
     */
    BLNO?: string;
    /**
     * 
     */
    Bills?: DtoListItemBill[];
    /**
     * 
     */
    IsFinish?: boolean;
}

/**
 * -表单校验
 */
export const DtoRequestFinishPoolBillRules = {
}
